module.exports = {
  MD_ORI_ID: 'k8vif92e',
  MD_MERCHANT_ID: 'onerway_uk',
  GOOGLE_PAY: {
    ENV: 'PRODUCTION',
  },
  GA_TAG_ID: 'G-PBBRWJDMSQ',
};
